module.exports = __webpack_public_path__ + "static/img/5.ecf7690.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/5.png
// module id = q5nR
// module chunks = 0